<form class="card mb-2" [formGroup]="form">
    <div class="card-header pb-3 pt-3" id="target1">
        Consultar cliente
    </div>
    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>No. Identificación</mat-label>
            <input type="text" formControlName="n_ide" matInput>
        </mat-form-field>

        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Cuenta</mat-label>
            <input type="number" formControlName="cue" matInput>
        </mat-form-field>

    </div>

    <div class="card-footer pb-2 pt-2">
        <button mat-button class="primary" (click)="buscar()">
            Consultar
        </button>
    </div>
</form>

<div class="card mb-2" id="target2" *ngIf="step > 1">
    <div class="card-header pb-3 pt-3">
        Información de la cuenta
    </div>
    <div class="card-body m-0 p-2 pb-4">
        <table mat-table [dataSource]="dsInfoCuenta" class="mat-elevation-z8">
            <ng-container [matColumnDef]="column.name" *ngFor="let column of columnsInfoCuenta">
                <th mat-header-cell *matHeaderCellDef> {{column.value}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column.name]}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsInfoCuenta"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsInfoCuenta;"></tr>
        </table>
    </div>
</div>

<form class="card mb-2" [formGroup]="formAcuerdo" *ngIf="step > 1">
    <div class="card-header pb-3 pt-3">
        Acuerdo
    </div>
    <div class="card-body row m-0 p-2 pb-3">
        <!--
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Seleccionar Plazo</mat-label>
            <mat-select formControlName="acuerdo" (valueChange)="modStep(2)">
                <mat-option></mat-option>
                <mat-option [value]="p.cuota_ini" *ngFor="let p of plazos">{{p.cuota_ini + (p.cuota_ini==1?" MES":" MESES")}}</mat-option>
            </mat-select>
        </mat-form-field>
        -->
        <mat-form-field appearance="fill" class="col-12 col-md-12">
            <mat-label>Saldo Inicial</mat-label>
            <input type="number" formControlName="saldo_ini" (change)="modStep(2)" matInput>
        </mat-form-field>
    </div>

    <div class="card-footer pb-2 pt-2">
        <button mat-button class="primary" (click)="simularAcuerdo()">
            Simular
        </button>
    </div>
</form>

<div class="card mb-2" id="target3" *ngIf="step > 2">
    <div class="card-header pb-3 pt-3">
        Simulación
    </div>
    <div class="card-body m-0 p-2 pb-4">

        <table class="mb-3" mat-table [dataSource]="dsSimu">
            <ng-container [matColumnDef]="column.name" *ngFor="let column of columnsSimu">
                <th mat-header-cell *matHeaderCellDef> {{column.value}} </th>
                <td mat-cell *matCellDef="let element"> 
                    {{column.name === 'btn_acciones' ?'':element[column.name]}} 
                    <button *ngIf="column.name === 'btn_acciones'" mat-button class="btn btn-lg" (click)="aplicarAcuerdo()">Aplicar</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsSimu"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSimu;"></tr>
        </table>
        <!-- 
        <div class="scroll">
            <table mat-table [dataSource]="dsPlan">
                <ng-container [matColumnDef]="column.name" *ngFor="let column of columnsPlan">
                    <th mat-header-cell *matHeaderCellDef> {{column.value}} </th>
                    <td mat-cell *matCellDef="let element"> {{element[column.name]}} </td>
                </ng-container>
    
                <tr mat-header-row *matHeaderRowDef="displayedColumnsPlan"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsPlan;"></tr>
            </table>
        </div>
        --> 
    </div>

    <div class="card-footer pb-2 pt-2">
        <button mat-button class="primary" (click)="aplicarAcuerdo()">
            Aplicar
        </button>
    </div>
</div>

<div class="card" id="target4" *ngIf="step > 3">
    <div class="card-header pb-3 pt-3">
        Plan de amortización
    </div>
    <div class="card-body m-0 p-2 pb-4 scroll">
        <table mat-table [dataSource]="dsPlan">
            <ng-container [matColumnDef]="column.name" *ngFor="let column of columnsPlan">
                <th mat-header-cell *matHeaderCellDef> {{column.value}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column.name]}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsPlan"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsPlan;"></tr>
        </table>
    </div>

    <div class="card-footer pb-2 pt-2">
        <button mat-button class="primary" (click)="nuevaConsulta()">
            Nueva consulta
        </button>
    </div>
</div>